import { MiniCartStyleTokens } from "./miniCart.tokens";

export const MiniCartStyles: MiniCartStyleTokens = {
    orderButton: {
        color: "secondary"
    }
};
